<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <input
      matInput
      formControlName="codiceUnico"
      [placeholder]="'Codice Unico' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="SGT.SGTI"
      [placeholder]="'Identificazione' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="OGT.OGTD"
      [placeholder]="'Oggetto' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="LRO"
      [placeholder]="'Occasione' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="CPR.CPRN"
      [placeholder]="'Diritti d\'autore' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="LRD"
      [placeholder]="'Data ripresa' | translate">
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      formControlName="MTX"
      [placeholder]="'MTX' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="MIS.MISA"
      [placeholder]="'Altezza' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="MIS.MISL"
      [placeholder]="'Larghezza' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="FVC.FVCF"
      [placeholder]="'Formato memorizzazione' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="FVC.FVCU"
      [placeholder]="'Unità di misura' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="FVC.FVCM"
      [placeholder]="'Misure fotografia virtuale' | translate">
  </mat-form-field>
</form>
